module.exports = __webpack_public_path__ + "s/img/Play_D_2.48964108.jpg";